export default "__VITE_ASSET__I3N21xBy__"